import { render, staticRenderFns } from "./ProfitOrLosesAmountInTable.html?vue&type=template&id=5d0e89dc&scoped=true&"
import script from "./ProfitOrLosesAmountInTable.js?vue&type=script&lang=js&"
export * from "./ProfitOrLosesAmountInTable.js?vue&type=script&lang=js&"
import style0 from "./ProfitOrLosesAmountInTable.scss?vue&type=style&index=0&id=5d0e89dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e89dc",
  null
  
)

export default component.exports